import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { Lists } from '../types/items';
class ListService {
  private route = apis.lists;

  constructor(private api: ApiService) {
  }

  get = () => this.api.get<Lists>(this.route);

}


export default new ListService(apiService);
